module.exports = [
  {
    path: '/login',
    component: () => import('@/views/login/index')
  },
  {
    path: '',
    component: true,
    redirect: '/home',
    children: [{
      path: 'home',
      name: '首页',
      component: () => import('@/views/home/index')
    }]
  },
  {
    path: '/personal',
    component: true,
    redirect: '/personal/password',
    name: '我的',
    children: [
      {
        path: 'password',
        name: '修改密码',
        component: () => import('@/views/personal/password/index')
      }
    ]
  },
  { path: '/404', component: () => import('@/views/404') },
  { path: '*', redirect: '/404' }
]


// WEBPACK FOOTER //
// ./src/router/common.js